module.exports = __webpack_public_path__ + "static/media/kayak_border_46.dc3a5076.png";